import React, { useState } from 'react';
import {
  Box,
  Textarea,
  Flex,
  InputGroup,
  InputRightElement,
  Text,
  HStack,
  Image,
  useToast,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Input,
  Button,
  ModalFooter,
} from '@chakra-ui/react';
import { IconButton, Switch } from "@mui/material";
// import {Switch} from "@chakra-ui/react";
// import {Switch} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import EmptyScreen from './EmptyScreen';
import MessageTile from './MessageTile';
import { useParams } from 'react-router-dom';

import { useWebSocket } from '../../internal/messaging/WebSocketContext';
import FileIcon from '../../components/FileIcon';
import { FilterAlt, FilterAltOutlined, Folder, FolderOutlined, SellOutlined, Tune, TuneOutlined } from '@mui/icons-material';

function ChatInput({ showWorkspace, workspaceOpened }) {
  const [inputValue, setInputValue] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const { taskId } = useParams();
  // const [messages, setMessages] = useState([]); // Store received messages
  const toast = useToast();
  const ws = React.useRef(null); // Use useRef to store WebSocket instance
  const fileInputRef = React.useRef(null);
  const { messages, sendMessage, systemErrorMessage, firstChatMessage } = useWebSocket();
  const messagesEndRef = React.useRef(null); // Ref for auto-scroll
  const inputRef = React.useRef(null);
  const [isTagModalOpen, setIsTagModalOpen] = useState(false);
  const [tags, setTags] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [searchInLibrary, setSearchInLibrary] = useState(false);

  const tagKeys = ["Document Type"];

  const tagValuesMap = {
    "Document Type": ["Project Summary", "Case Study", "Certifications", "Reference Letters", "Resume", "Technical Specs"]
  };

  React.useEffect(() => {
    const storedPrompt = localStorage.getItem("rootPromptText");
    if (storedPrompt) {
        prompt = JSON.parse(storedPrompt);
        console.log("ChatInput Prompt is",prompt.promptText)
        setInputValue(prompt.promptText)
        localStorage.removeItem("rootPromptText");
    }
  }, [])

  const myMessages = getMessages();
  React.useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);
  React.useEffect(() => {
    // Focus the textarea when the component mounts
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, []);

  React.useEffect(() => {
    if (systemErrorMessage) {
      toast({
        title: 'Error',
        description: systemErrorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  }, [systemErrorMessage])

  const handleSendMessage = async () => {
    if (inputValue.trim() === '') {
      return;
    }
    // if (!selectedFile) return;
    let fileData;
    if (selectedFile) {
      fileData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(selectedFile);
      });
    }
    const fileNewData = fileData;
    const fileType = selectedFile?.type
    console.log('fileNewData', fileNewData);
    console.log('file type in send message', fileType);

    const allFilterTags = tags.filter(tag => tag.tag_key.trim() !== '' && tag.tag_value.trim() !== '');
    const myMessage = {
      text: inputValue,
      files: selectedFile
        ? [
            {
              name: fileName,
              data: fileNewData,
              type: fileType,
            },
          ]
        : [],
      filter_tags: allFilterTags ? allFilterTags.map((tag) => ({
        tag_key: tag.tag_key,
        tag_value: tag.tag_value,
      })) : [],
      configuration: {
        search_in_library: searchInLibrary,
      }
    };
    if (messages?.length === 0) {
      // this is http call
      firstChatMessage(myMessage);
    } else {
      // sendMessage({
      //   type: 'simple_message',

      //   simple_message: {
      //     text: inputValue,
      //     file_data: fileData ? fileData : '',
      //     filename: fileName || '',
      //     file_type: fileType,
      //     port: 'chat',
      //     filter_tags: allFilterTags ? allFilterTags.map((tag) => ({
      //       tag_key: tag.tag_key,
      //       tag_value: tag.tag_value,
      //     })) : [],
      //     configuration: {
      //       search_in_library: searchInLibrary,
      //     }
      //   },
      // });
      sendMessage(myMessage)
    }

    setInputValue('');
    setSelectedFile(null);
    setSearchInLibrary(false);
    setFileName('');
  };

  // Handle file attachment
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setSearchInLibrary(false);
      console.log(file);
      console.log(file.name);
      setFileName(file.name); // Get and set the filename
    }
  };

  function getMessages() {
    return (messages || [])
      .reduce((acc, message, index) => {
        const filteredAcc = acc.filter((msg) => 
          msg?.simple_message?.port === 'chat' || 
          msg?.simple_html_message?.port === 'chat' || 
          msg?.simple_message?.port === 'thinking'
        );
        const isThinking = message.simple_message?.port === 'thinking';
        const isChatMessage = (message.simple_message?.port === 'chat' || message.simple_html_message?.port === 'chat');
        const isPrevThinking =
          filteredAcc.length > 0 &&
          filteredAcc[filteredAcc.length - 1]?.simple_message?.port === 'thinking';
  
        if (isThinking) {
          if (!isPrevThinking) {
            acc.push(message);
          } else {
            acc = acc.filter((msg) => msg?.simple_message?.port !== 'thinking'); // Remove all the "thinking" message
            acc.push(message);
          }
        } else {
          if (isPrevThinking && isChatMessage) {
            acc = acc.filter((msg) => msg?.simple_message?.port !== 'thinking'); // Remove all the "thinking" message
          }
          acc.push(message); // Add the new non-thinking message
        }
  
        return acc;
      }, [])
      .filter(
        (message) =>
          message.type !== 'planner_message' &&
          message.type !== 'action_message'
      );
  }

  const textareaRef = React.useRef(null);

  // Adjust Textarea height dynamically
  const handleInput = (e) => {
    const textarea = textareaRef.current;
    textarea.style.height = 'auto'; // Reset height
    const scrollHeight = textarea.scrollHeight;
    textarea.style.height = `${Math.min(scrollHeight, 100)}px`; // Limit height to 200px
  };

  if (messages?.length === 0) {
    return (
      <Box
        height="calc(100vh - 61px)" // Full viewport height
        display="flex"
        flexDirection="column"
        maxW={"100%"}
        // paddingTop="24px"
      >
        <Box flex="1" overflowY="auto" pb={0} data-scrollable="true" maxW={"100%"}>
          <EmptyScreen setInputValue={setInputValue} />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      height="calc(100vh - 61px)" // Full viewport height
      display="flex"
      flexDirection="column"
      paddingTop="24px"
    >
      <Box flex="1" overflowY="auto" pb={2} data-scrollable="true">
        {messages?.length === 0 ? (
          <EmptyScreen setInputValue={setInputValue} />
        ) : (
          <Box paddingRight={0} marginX={ workspaceOpened ? "4.5%" : "10%"}>
            {myMessages.map((msg, index) => (
              <Box key={index} p={0} borderRadius="md">
                <MessageTile message={msg} workspaceOpened={workspaceOpened} prevMsg={index == 0 ? null : myMessages[index-1]}/>
              </Box>
            ))}
            {/* Scroll to this element */}
            <div ref={messagesEndRef} />
          </Box>
        )}
      </Box>
      <Box p={0} paddingTop={0} position="sticky" bottom="0" marginX={workspaceOpened ? "5%" : "10.5%"} 
        // marginLeft={"0.3%"}
      >
        <Flex direction="column" align="stretch">
          {/* File preview (if a file is selected) */}
          {selectedFile && (
            <HStack
              border="1px solid"
              borderColor="gray.300"
              p={2}
              px={1}
              borderRadius="md"
              borderBottom="0px"
              mx={2}
              mb={-2}
              align="center"
              justify="space-between"
            >
              <HStack>
                <FileIcon
                  fileExtension={selectedFile.name.split('.').reverse()[0]}
                />
                <Text fontSize="sm">{selectedFile.name}</Text>
              </HStack>

              <IconButton label="Remove file" sx={{"&:hover": { backgroundColor: "transparent"}}}  onClick={() => setSelectedFile(null)}><CloseIcon sx={{ fontSize: 28, color: "#5d5d5d" }}/></IconButton>
            </HStack>
          )}

          {/* my new input */}
          <Flex
            // bg="#F6F8FA"
            bg="gray.50"
            borderRadius="24px"
            align="center"
            p={2}
            boxShadow="lg"
            // maxW="800px"
            w="100%"
            marginBottom={"48px"}
            border={'1px solid #E5E5E5'}
            // minH={'88px'}
          >
            {/* Attachment Icon */}
            <Tooltip
              label="Your file formats must be of type .pdf, .docx, .pptx, .csv, .xlsx, .jpeg, .jpg, .png, .txt, .zip"
              placement="top"
              hasArrow
            >
              <IconButton 
                sx={{paddingX: "4px", "&:hover":{backgroundColor: "transparent"}}}
                aria-label="Attach File"
                onClick={() => fileInputRef.current?.click()} // Move the onClick handler here
              >
                <AttachFileIcon sx={{paddingX: "0px", fontSize: 28, color: "#5d5d5d"}}/>
              </IconButton>
            </Tooltip>
            <input
              type="file"
              id="file-input"
              style={{ display: 'none' }}
              ref={fileInputRef}
              onChange={(event) => {
                handleFileChange(event);
                // Reset the value ONLY when a file is actually selected
                if (event.target.files.length > 0) {
                  fileInputRef.current.value = "";
                }
                }}
                />

                <Box position="relative" onMouseEnter={() => setShowMenu(true)} onMouseLeave={() => setShowMenu(false)}>
                {/* <IconButton 
                  sx={{paddingX: "4px", "&:hover":{backgroundColor: "transparent"}}}
                  aria-label="Filter"
                  onClick={() => setIsTagModalOpen(true)} // Open the modal
                >
                  {
                  tags.filter(tag => tag.tag_key.trim() !== '' && tag.tag_value.trim() !== '').length > 0 ? (
                  <>
                  <Box
                    position="absolute"
                    top="-2px"
                    right="-5px"
                    bg="red.500"
                    color="white"
                    borderRadius="full"
                    fontSize="10px"
                    fontWeight="bold"
                    width="16px"
                    height="16px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {tags.filter(tag => tag.tag_key.trim() !== '' && tag.tag_value.trim() !== '').length}
                  </Box>
                  <Tune sx={{paddingX: "0px", fontSize: 28, color: "#5d5d5d"}}/>
                  </>
                  ) : (
                  <TuneOutlined sx={{paddingX: "0px", fontSize: 28, color: "#5d5d5d"}}/>
                  )
                  }
                </IconButton> */}

                {showMenu && (
                  <Box
                    position="absolute"
                    top="-100px"
                    left="0"
                    bg="white"
                    boxShadow="md"
                    borderRadius="md"
                    zIndex="10"
                    p={2}
                    _after={{
                    content: '""',
                    position: "absolute",
                    bottom: "-10px",
                    left: "8px", // Adjust this to align the beak with the button
                    width: "0",
                    height: "0",
                    borderLeft: "10px solid transparent",
                    borderRight: "10px solid transparent",
                    borderTop: "10px solid white",
                  }}
                  >
                    <HStack
                      width={"156px"}
                      padding={"8px"}
                      onClick={() => setIsTagModalOpen(true)}
                    >
                      <IconButton
                        sx={{padding: "0px", "&:hover":{backgroundColor: "transparent"}}}
                      >
                        <FolderOutlined sx={{paddingX: "0px", fontSize: 22, color: "#5d5d5d"}}/>
                      </IconButton>
                      <Text
                        fontSize="16px"
                        cursor="pointer">
                        Library Folders
                      </Text>
                    </HStack>
                    <HStack
                      padding={"8px"}
                      onClick={() => setIsTagModalOpen(true)}
                    >
                      <IconButton
                        sx={{padding: "0px", "&:hover":{backgroundColor: "transparent"}}}
                      >
                        <SellOutlined sx={{paddingX: "0px", fontSize: 22, color: "#5d5d5d"}}/>
                      </IconButton>
                      <Text
                        fontSize="16px"
                        cursor="pointer">
                          Tags
                      </Text>
                    </HStack>
                  </Box>
                )}
                </Box>

                {/* Modal for adding key-value pairs */}
              {isTagModalOpen && (
                <Modal isOpen={isTagModalOpen} onClose={() => setIsTagModalOpen(false)}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader>Refine with filters</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                  <HStack justifyContent="space-between">
                    <Text fontSize="18px" mb={2}>
                      Tags
                    </Text>
                    {/* <Button
                      fontSize={"14px"}
                      onClick={() =>
                        setTags((prevTags) => [...prevTags, { tag_key: '', tag_value: '' }])
                    }
                    >
                      Add Tag
                    </Button> */}
                  </HStack>
                  {/* <Text
                    fontSize="14px"
                    mb={2}
                    color="gray.500"
                  >
                    Select key value tags to guide Thalamus' answers
                  </Text> */}
                  {
                    tags.length > 0 && (
                      <VStack spacing={4} mb={4}>
                        {tags.map((tag, index) => (
                        <HStack key={index} spacing={2} width="100%" position="relative">
                          <Input
                          placeholder="Key"
                          value={tag.tag_key}
                          onChange={(e) =>
                            setTags((prevTags) =>
                            prevTags.map((t, i) =>
                              i === index ? { ...t, tag_key: e.target.value } : t
                            )
                            )
                          }
                          onFocus={() => {
                            setTags((prev) => {
                              const newTags = [...prev];
                              if (newTags[index]) {
                                newTags[index].showKeyDropdown = true;
                              }
                              return newTags;
                            });
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setTags((prev) => {
                                const newTags = [...prev];
                                if (newTags[index]) {
                                  newTags[index].showKeyDropdown = false;
                                }
                                return newTags;
                              });
                            }, 200); // Delay to allow click on dropdown
                          }}
                          />

                          {tag.showKeyDropdown && (
                              <Box
                                position="absolute"
                                top={"100%"}
                                left={"4px"}
                                width="40%"
                                backgroundColor="white"
                                border="1px solid #E4E4E4"
                                borderRadius="8px"
                                zIndex="10"
                                maxHeight="150px"
                                overflowY="auto"
                                data-scrollable="true"
                              >
                                {(() => {

                                  return tagKeys.filter((option) =>
                                    option.toLowerCase().includes(tag.tag_key.toLowerCase())
                                  ).map((filteredOption, idx) => (
                                    <Box
                                      key={idx}
                                      padding="8px"
                                      _hover={{ backgroundColor: "#F6F8FA", cursor: "pointer" }}
                                      onClick={() => {
                                        setTags((prev) => {
                                          const newTags = [...prev];
                                          newTags[index].tag_key = filteredOption;
                                          newTags[index].showKeyDropdown = false;
                                          return newTags;
                                        });
                                      }}
                                    >
                                      {filteredOption}
                                    </Box>
                                  ));
                                })()}
                              </Box>
                          )}
                          <Input
                          placeholder="Value"
                          value={tag.tag_value}
                          onChange={(e) =>
                            setTags((prevTags) =>
                            prevTags.map((t, i) =>
                              i === index ? { ...t, tag_value: e.target.value } : t
                            )
                            )
                          }
                          onFocus={() => {
                            setTags((prev) => {
                              const newTags = [...prev];
                              if (newTags[index]) {
                                newTags[index].showValueDropdown = true;
                              }
                              return newTags;
                            });
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setTags((prev) => {
                                const newTags = [...prev];
                                if (newTags[index]) {
                                  newTags[index].showValueDropdown = false;
                                }
                                return newTags;
                              });
                            }, 200); // Delay to allow click on dropdown
                          }}
                          />
                          {tag.showValueDropdown && (
                              <Box
                                position="absolute"
                                top={"100%"}
                                left={`calc(40% + 24px)`}
                                width="40%"
                                backgroundColor="white"
                                border="1px solid #E4E4E4"
                                borderRadius="8px"
                                zIndex="10"
                                maxHeight="150px"
                                overflowY="auto"
                                data-scrollable="true"
                              >
                                {(() => {
                                  const optionsToShow = tagValuesMap[tag.tag_key] || [];

                                  return optionsToShow.filter((option) =>
                                    option.toLowerCase().includes(tag.tag_value.toLowerCase())
                                  ).map((filteredOption, idx) => (
                                    <Box
                                      key={idx}
                                      padding="8px"
                                      _hover={{ backgroundColor: "#F6F8FA", cursor: "pointer" }}
                                      onClick={() => {
                                        setTags((prev) => {
                                          const newTags = [...prev];
                                          newTags[index].tag_value = filteredOption;
                                          newTags[index].showValueDropdown = false;
                                          return newTags;
                                        });
                                      }}
                                    >
                                      {filteredOption}
                                    </Box>
                                  ));
                                })()}
                              </Box>
                          )}
                          <IconButton
                            sx={{
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                            aria-label="Remove Tag"
                            onClick={() =>
                              setTags((prevTags) =>
                                prevTags.filter((_, i) => i !== index)
                              )
                            }
                          >
                            <CloseIcon sx={{ fontSize: 28, color: "#5d5d5d" }} />
                          </IconButton>
                        </HStack>
                        ))}
                      </VStack>
                    )
                  }
                  <HStack
                    width={"100%"}
                    justifyContent={"space-between"}
                  >
                    <Box>
                    </Box>
                    <Button
                      color={"white"}
                      bgColor={"#2584FD"}
                      _hover={{
                        backgroundColor: "#2584FD",
                      }}
                      padding={"8px"}
                      fontSize={"14px"}
                      onClick={() =>
                        setTags((prevTags) => [...prevTags, { tag_key: '', tag_value: '' }])
                    }
                    >
                      Add Tag
                    </Button>
                  </HStack>
                  <HStack justifyContent="space-between">
                    <Text fontSize="18px" mb={2}>
                      Library Folders
                    </Text>
                  </HStack>
                  {/* <Text
                    fontSize="14px"
                    mb={2}
                    color="gray.500"
                  >
                    Select folders from content library to guide Thalamus' answers
                  </Text> */}
                  <HStack
                    width={"100%"}
                    justifyContent={"space-between"}
                  >
                    <Box>
                    </Box>
                    <Button
                        marginLeft={"auto"}
                        fontSize={"14px"}
                        onClick={() =>
                          setTags((prevTags) => [...prevTags, { tag_key: '', tag_value: '' }])
                        }
                        isDisabled={true}
                      >
                        Add Folder
                      </Button>
                  </HStack>
                  </ModalBody>
                  <ModalFooter>
                  <Button variant="ghost" onClick={() => setIsTagModalOpen(false)}>
                    Close
                  </Button>
                  </ModalFooter>
                </ModalContent>
                </Modal>
              )}

            <Box flex="1" mx={2} my={2}>
              <Textarea
                ref={textareaRef}
                placeholder="Hi there, how can I assist you today?"
                resize="none"
                rows={1} // Default single line
                maxH="200px" // Prevent growing beyond 200px
                overflowY="auto"
                value={inputValue}
                onInput={handleInput}
                border="none"
                focusBorderColor="transparent"
                _focus={{ outline: 'none', boxShadow: 'none' }}
                sx={{
                  fontSize: '16px',
                  lineHeight: '1.5',
                }}
                borderTopRadius={'16px'}
                bg={'white'}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    console.log('message clicked');
                    e.preventDefault(); // Prevents the default newline behavior
                    handleSendMessage(); // Calls the sendMessage function
                  }
                }}
                />
                <Flex align="center" backgroundColor={"white"} borderBottomRadius={"16px"} paddingTop={"4px"} paddingLeft={"4px"} paddingBottom={"8px"}>
                  <HStack
                  border={"1px solid"}
                  borderColor={searchInLibrary ? "#2584FD" : "#E5E5E5"}
                  gap={0}
                  height={"32px"}
                  borderRadius={"16px"}
                  // p={0}
                    >
                    <Box
                    width={"48px"}
                    >
                    <Tooltip
                      label="Search library is disabled when a file is attached"
                      placement="top"
                      isDisabled={!selectedFile} // Show tooltip only when the switch is disabled
                      hasArrow
                    >
                      <Box>
                      <Switch
                        colorScheme="custom"
                        sx={{
                          transform: 'scale(0.8)', // Decrease the size of the switch
                          '& .MuiSwitch-thumb': {
                            backgroundColor: searchInLibrary ? '#2584FD' : '#E5E5E5',
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: searchInLibrary ? '#2584FD' : 'grey',
                          },
                          '& .MuiSwitch-switchBase': {
                            transition: 'all 0.4s ease', // control movement
                          },
                        }}
                        checked={searchInLibrary}
                        disabled={selectedFile ? true : false}
                        onChange={(e) => setSearchInLibrary(e.target.checked)}
                      />
                      </Box>
                    </Tooltip>
                    </Box>
                    <Text fontSize="14px" mr={2}>
                      Search Library
                    </Text>
                    </HStack>
                  </Flex>
                  </Box>
                  
                  <Box paddingX={"4px"}>
                  <IconButton 
                    aria-label="Send Message"
                    sx={{
                    bgcolor: inputValue.trim() !== '' ? "#3b8cff" : "#C4E0FF",
                    '&:hover': {
                    backgroundColor: inputValue.trim() !== '' ? "#3b8cff" : "#C4E0FF", // Keep the background color same on hover
                    },
                  }}
                  onClick={handleSendMessage}
                >
                <SendIcon sx={{padding: "0px", fontSize: 28, color: "#ffffff"}}/>
              </IconButton>
            </Box>
          </Flex>

          {/* my new input end */}

          {/* Textarea for the message */}
        </Flex>
      </Box>
    </Box>
  );
}

export default ChatInput;
